"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var grid_maker_1 = require("../../../model/tables/grid/grid-maker");
var Grid = (function () {
    function Grid(table) {
        this.table = table;
        this.tableCellGridInfos = [];
        this.tableCellInfos = [];
        grid_maker_1.GridMaker.fillGridInfo(table, this.tableCellGridInfos, this.tableCellInfos);
    }
    Object.defineProperty(Grid.prototype, "commonWidth", {
        get: function () {
            return list_1.ListUtils.last(this.columns.positions);
        },
        enumerable: false,
        configurable: true
    });
    return Grid;
}());
exports.Grid = Grid;
